import React, { useEffect, useRef, useState } from 'react'
import { css as hcss } from '@emotion/css'
import { css } from '@emotion/native'
import { Animated } from 'react-native'

type Props = {
  isResp?: boolean
}
const imgStyle = css({
  position: 'absolute',
  resizeMode: 'cover',
})
const Parallax: React.FC<Props> = ({ isResp }) => {
  const [xPivot, setXPivot] = useState(0)
  const [yPivot, setYPivot] = useState(0)
  let step = 1

  const animOpacity = useRef(new Animated.Value(0))
  const anim = useRef(new Animated.Value(0))

  useEffect(() => {
    Animated.parallel([
      Animated.timing(animOpacity.current, {
        toValue: 1,
        duration: 800,
        useNativeDriver: true,
      }),
      Animated.timing(anim.current, {
        toValue: 50,
        duration: 1000,
        useNativeDriver: true,
      }),
    ]).start()
  }, [])

  const box = hcss`
    perspective: 1000px;
    transform-style: preserve-3d;
    height  : 600px;
    transition : 1s cubic-bezier(.2,.9,.3,1.3); 
    position : absolute;
    width : 100%;
`
  const imgTab = [
    {
      img: 'red_rectangle.svg',
      left: '10%',
      top: 400,
      width: 50,
      height: 70,
    },
    {
      img: 'yellow_rectangle.svg',
      left: '80%',
      top: 300,
      width: 30,
      height: 40,
    },
    {
      img: 'red_rectangle.svg',
      left: '70%',
      top: 400,
      width: 50,
      height: 70,
    },
    {
      img: 'yellow_rectangle.svg',
      left: '25%',
      top: 300,
      width: 30,
      height: 40,
    },
    {
      img: 'blue_rectangle.svg',
      left: '85%',
      top: 200,
      width: 30,
      height: 40,
    },
    {
      img: 'blue_rectangle.svg',
      left: '20%',
      top: 200,
      width: 50,
      height: 70,
    },
    {
      img: 'blue_rectangle.svg',
      left: '50%',
      top: 400,
      width: 30,
      height: 40,
    },
    {
      img: 'dotted_rectangle.svg',
      left: '80%',
      top: 240,
      width: 50,
      height: 70,
    },
    {
      img: 'dotted_red_rectangle.svg',
      left: '30%',
      top: 350,
      width: 30,
      height: 40,
    },
    {
      img: 'dotted_rectangle.svg',
      left: '65%',
      top: 350,
      width: 50,
      height: 70,
    },
    {
      img: 'dotted_red_rectangle.svg',
      left: '27%',
      top: 200,
      width: 30,
      height: 40,
    },
  ]

  const imgTabResp = [
    {
      img: 'red_rectangle.svg',
      left: '75%',
      top: 350,
      width: 50,
      height: 50,
    },
    {
      img: 'yellow_rectangle.svg',
      left: '20%',
      top: 300,
      width: 30,
      height: 40,
    },
    {
      img: 'blue_rectangle.svg',
      left: '10%',
      top: 90,
      width: 30,
      height: 50,
    },
    {
      img: 'blue_rectangle.svg',
      left: '80%',
      top: 200,
      width: 30,
      height: 40,
    },
    {
      img: 'dotted_rectangle.svg',
      left: '80%',
      top: 100,
      width: 30,
      height: 40,
    },
    {
      img: 'dotted_red_rectangle.svg',
      left: '10%',
      top: 350,
      width: 30,
      height: 40,
    },
  ]

  return (
    <>
      {isResp ? (
        imgTabResp.map((i) => {
          return (
            <Animated.Image
              style={[
                imgStyle,
                {
                  left: i.left,
                  top: i.top,
                  width: i.width,
                  height: i.height,
                  transform: [{ translateY: anim.current }],
                  zIndex : -10
                },
              ]}
              source={{ uri: `/img/demo/${i.img}` }}
            />
          )
        })
      ) : (
        <div
          style={{
            transform:
              ' rotateY( ' + yPivot + 'deg) rotateX( ' + xPivot + 'deg)',
          }}
          className={box}
          onMouseMove={(e: any) => {
            setYPivot(e.clientX / 80)
            setXPivot(e.clientY / 40)
          }}
        >
          {imgTab.map((i) => {
            return (
              <Animated.Image
                style={[
                  imgStyle,
                  {
                    left: i.left,
                    top: i.top,
                    width: i.width,
                    height: i.height,
                    transform: [{ translateZ: 20 * step++ }],
                  },
                ]}
                source={{ uri: `/img/demo/${i.img}` }}
              />
            )
          })}
        </div>
      )}
    </>
  )
}

export default Parallax
